import APIConfig from 'config'
import isEmpty from 'lodash/isEmpty'
import { urlHelpers } from 'utils'
import AbstractService from './AbstractService'

export default class AudioService extends AbstractService {
  static getToken(trackid) {
    return this.get(APIConfig.endpoints.audioToken.replace('{0}', trackid))
  }

  static getAudioStreamURL(token) {
    const result =
      import.meta.env.VITE_BASE_URL +
      '/' +
      APIConfig.endpoints.audioStream.replace('{0}', token)
    return result
  }

  static getAudioDownloadURL(token, queryParams = {}) {
    let params = ''
    if (!isEmpty(queryParams)) {
      params = urlHelpers.buildQueryParamsString(queryParams)
    }

    const result =
      import.meta.env.VITE_BASE_URL +
      '/' +
      APIConfig.endpoints.audioDownload.replace('{0}', token) +
      params
    return result
  }

  static getVideoDownloadURL(token) {
    const result =
      import.meta.env.VITE_BASE_URL +
      '/' +
      APIConfig.endpoints.videoDownload.replace('{0}', token)
    return result
  }

  static getAudioZipper(releaseID, params) {
    let format = ''
    if (!isEmpty(params)) {
      format = params?.format
    }

    return this.get(
      `${APIConfig.endpoints.audioZipper.replace(
        '{0}',
        releaseID
      )}?format=${format}&bitrate=320`
    )
  }

  static getAudioZipperStatus(token) {
    return this.get(APIConfig.endpoints.audioZipperStatus.replace('{0}', token))
  }

  static getPlaylistZipper(playlistid, params) {
    let format = ''
    if (!isEmpty(params)) {
      format = params?.format
    }

    return this.get(
      `${APIConfig.endpoints.playlistZipper.replace(
        '{0}',
        playlistid
      )}?format=${format}&bitrate=320`
    )
  }

  static getPlaylistZipperStatus(token) {
    return this.get(
      APIConfig.endpoints.playlistZipperStatus.replace('{0}', token)
    )
  }
}
